import { reactive } from 'vue';

const variants = {
    warning: {
        classButton: 'btn-warning',
        icon: 'exclamation-triangle',
        iconClass: 'text-amber-500',
        iconBgClass: 'bg-amber-100 dark:bg-amber-500/10',
    },
    info: {
        classButton: 'btn-info',
        icon: 'info-circle',
        iconClass: 'text-blue-500',
        iconBgClass: 'bg-blue-100 dark:bg-blue-500/10',
    },
    danger: {
        classButton: 'btn-danger',
        icon: 'exclamation-circle',
        iconClass: 'text-red-500',
        iconBgClass: 'bg-red-100 dark:bg-red-500/10',
    },
};

const state = reactive({
    open: false,
    variant: 'danger',
    title: '',
    message: '',
    confirmText: 'Valider',
    cancelText: 'Annuler',
    action: null,
});

let onSettle = null;

/**
 * Ouvre la modal de confirmation globale et retourne une promesse résolue
 * avec `true`/`false` selon le choix de l'utilisateur. Si une `action` est
 * fournie, elle est exécutée (avec gestion du loader) avant la fermeture.
 */
function confirm({ variant = 'danger', title = '', message = '', confirmText = 'Valider', cancelText = 'Annuler', action = null } = {}) {
    state.variant = variants[variant] ? variant : 'danger';
    state.title = title;
    state.message = message;
    state.confirmText = confirmText;
    state.cancelText = cancelText;
    state.action = action;
    state.open = true;

    return new Promise((resolve) => {
        onSettle = resolve;
    });
}

async function handleConfirm() {
    if (state.action) {
        await state.action();
    }

    state.open = false;
    onSettle?.(true);
}

function handleCancel() {
    state.open = false;
    onSettle?.(false);
}

export default {
    state,
    variants,
    confirm,
    handleConfirm,
    handleCancel,
};
